import axios from 'axios'
// import qs from 'qs'

axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})


const request = {
  post(url, data, paramsSign) {
    return axios({
      method: 'post',
      url,
      data,
      timeout: 30000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...paramsSign
      }
    }).then(
      (response) => {
        return response
      }
    )
  },
  get(url, params, paramsSign) {
    return axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: 30000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        // 'Content-Type' : "application/json;charset=utf-8",
        ...paramsSign
      }
    }).then(
      (response) => {
        return response
      }
    )
  }
}
export default request;